import { render } from "../templates/edit-variable-value.html?vue&type=template&id=10b8cac5"
import script from "./edit-variable-value.vue?vue&type=script&lang=js"
export * from "./edit-variable-value.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__